import type { ReactNode } from "react";
import type { IFeaturedIcon } from "libs/design-system/src/types/featured_icon/featuredIcon";
import { Check, Circle, Xmark } from "@unified-checkout/design-system/icons/index";
import { FeaturedIcon } from "@unified-checkout/design-system";
import type { ITimelineBox, ITimelineBoxStep } from "@app/dashboard/types/innerLayout/cards/timeline-box";
import { Card } from "../CardWrapper";
import styles from "./timeline-box.module.scss";

export const TimelineBox = ({
  width,
  height,
  title,
  steps,
}: ITimelineBox) => {

  const formattedValue = (value: string, emphasizedValue: string): ReactNode => {
    const splittedTitle = value.split(emphasizedValue);
    const importantText = <span className={styles["emphasized-text"]}>{emphasizedValue}</span>

    return <>{splittedTitle[0]}{importantText}{splittedTitle[1]}</>
  };

  const featuredIconProps = (status: ITimelineBoxStep['status'], icon: ITimelineBoxStep['icon']) => {
    const borderColor: IFeaturedIcon['color'] =
      status === 'success' ?
        'green'
        :
        status === 'failed' ?
          'red'
          :
          'gray';

    const Icon =
      status === 'success' ?
        Check
        :
        status === 'failed' ?
          Xmark
          :
          icon || Circle;

    return { color: borderColor, icon: Icon };
  };

  return (
    <Card
      width={width}
      height={height}
      title={title}
    >
      <div className={styles["timeline-box"]}>
        {
          steps?.map((step, index) =>
            <div className={styles["timeline-box__step"]} key={`timeline-box-step-${index}`}>

              <div className={styles["timeline-box__step__track"]}>
                <FeaturedIcon
                  size="sm"
                  variant="outlined"
                  {...featuredIconProps(step.status, step.icon)}
                />

              </div>
              <div className={styles["timeline-box__step__info"]}>
                {
                  step.title &&
                  <div className={styles["timeline-box__step__info__title"]}>
                    {
                      step.title.emphasizedValue ?
                        formattedValue(step.title.value, step.title.emphasizedValue)
                        :
                        step.title.value
                    }
                  </div>
                }
                {
                  step.description &&
                  <div className={styles["timeline-box__step__info__desc"]}>
                    {step.description}
                  </div>
                }
                {
                  step.date &&
                  <div className={styles["timeline-box__step__info__date"]}>
                    {step.date}
                  </div>
                }
              </div>
            </div>
          )
        }
      </div>
    </Card>
  )
};